import React from 'react';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

function Numbers() {
    return (
        <div className="skolkovo-kids__numbers">
            <div className="skolkovo-kids__numbers-inner">
                <div className="skolkovo-kids__numbers-list">
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                        delay={300}
                    >
                        <div className="skolkovo-kids__numbers-item">
                            <div className="skolkovo-kids__numbers-title">4300+</div>
                            <div className="skolkovo-kids__numbers-text">
                                подписчиков за&nbsp;8&nbsp;месяцев
                            </div>
                        </div>
                    </ScrollAnimation>
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                        delay={800}
                    >
                        <div className="skolkovo-kids__numbers-item">
                            <div className="skolkovo-kids__numbers-title">в 2 раза</div>
                            <div className="skolkovo-kids__numbers-text">
                                снизили стоимость подписчика
                            </div>
                        </div>
                    </ScrollAnimation>
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                        delay={1300}
                    >
                        <div className="skolkovo-kids__numbers-item">
                            <div className="skolkovo-kids__numbers-title">в 1,7</div>
                            <div className="skolkovo-kids__numbers-text">раз вырос CTR</div>
                        </div>
                    </ScrollAnimation>
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                        delay={1800}
                    >
                        <div className="skolkovo-kids__numbers-item">
                            <div className="skolkovo-kids__numbers-title">500+</div>
                            <div className="skolkovo-kids__numbers-text">
                                прирост подписчиков в месяц
                            </div>
                        </div>
                    </ScrollAnimation>
                </div>
            </div>
        </div>
    );
}

export default Numbers;
